<template>
  <GwMenu
    v-if="!$i18n.g1"
    :placement="placement"
    :isInside="isInside"
    :class="{ 'lang-menu-top-right': onTopRight }"
  >
    <template #opener>
      <slot name="opener">
        <div
          class="lang-svg-flag icon_btn pa-1"
          :class="lang.id"
        >
          <component :is="lang.flag" />
        </div>
      </slot>
    </template>
    <template #default="{ methods }">
      <LangSwitcher
        class="gw_menu f-column"
        style="padding: 0.5rem 0; max-height: 80vh"
        itemClass="navcard_appbar"
        @click.stop="
          e => {
            $emit('click', e)
            methods.toggleOpen(false)
          }
        "
      />
    </template>
  </GwMenu>
</template>

<script>
import LangSwitcher from '@/components/LangSwitcher/LangSwitcher'
import lang_mix from '@/components/LangSwitcher/lang_mix'
import GwMenu from '@/components/lib/GwMenu'

export default {
  name: 'LangMenu',
  components: {
    LangSwitcher,
    GwMenu,
  },
  mixins: [lang_mix],
  props: {
    isInside: Boolean,
    placement: {
      type: String,
      default: () => 'bottom-end',
    },
    onTopRight: Boolean,
  },
  emits: ['click'],
}
</script>
<style lang="scss" scoped>
.lang-menu-top-right {
  position: absolute;
  right: 2rem;
  top: 1rem;
  z-index: 99;
}
.lang-svg-flag {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  &.ko {
    background: white;
  }
  svg {
    width: 2.5rem;
    height: 2.5rem;
  }
}
</style>
